import { Component, computed, input } from '@angular/core';

import { ColorType } from '@camelot/styles';
import { TranslatePipe } from '@camelot/translation';
import { BadgeComponent } from '@camelot/ui';
import { CamBaseComponent } from '@camelot/utils';

import { CamTranslationProject } from '../../../../translation.service';
import { QuotationStatus } from '../../services/dto/quotation-status';

export const quotationStatusLabel = (quotationStatus: QuotationStatus) =>
  `project.quotation.status.${QuotationStatus[quotationStatus]?.toLowerCase() ?? 'unknown'}`;

const quotationStatusColors: Partial<Record<QuotationStatus, ColorType>> = {
  [QuotationStatus.Canceled]: 'new',
  [QuotationStatus.Draft]: 'purple',
  [QuotationStatus.Expired]: 'warning',
  [QuotationStatus.Refused]: 'alert',
  [QuotationStatus.Sent]: 'secondary',
  [QuotationStatus.Signed]: 'success',
};

@Component({
  selector: 'cam-quotation-status',
  templateUrl: './quotation-status.component.html',
  styleUrl: './quotation-status.component.scss',
  imports: [TranslatePipe, BadgeComponent],
})
export class CamQuotationStatusComponent extends CamBaseComponent {
  status = input.required<QuotationStatus>();

  color = computed<ColorType>(() => quotationStatusColors[this.status()] ?? 'purple');
  label = computed(() => quotationStatusLabel(Number(this.status())));

  constructor() {
    super();
    CamTranslationProject.getInstance();
  }
}
